import { 
  Smartphone, 
  Building2, 
  Landmark, 
  Bitcoin, 
  DollarSign, 
  Wallet,
  CreditCard 
} from 'lucide-react';

export const PAYMENT_METHOD_ICONS = {
  pago_movil: Smartphone,
  transferencia: Building2,
  deposito: Landmark,
  binance: Bitcoin,
  zelle: DollarSign,
  zinli: Wallet,
  wally: Wallet,
  custom: CreditCard,
};

export const PAYMENT_METHOD_COLORS = {
  pago_movil: 'from-blue-500 to-blue-600',
  transferencia: 'from-green-500 to-green-600',
  deposito: 'from-purple-500 to-purple-600',
  binance: 'from-yellow-500 to-yellow-600',
  zelle: 'from-indigo-500 to-indigo-600',
  zinli: 'from-pink-500 to-pink-600',
  wally: 'from-teal-500 to-teal-600',
  custom: 'from-gray-500 to-gray-600',
};

export const PAYMENT_METHOD_FIELDS = {
  pago_movil: [
    { name: 'banco', label: 'Banco', type: 'text', required: true },
    { name: 'cedula', label: 'Cédula', type: 'text', required: true },
    { name: 'telefono', label: 'Teléfono', type: 'tel', required: true },
  ],
  transferencia: [
    { name: 'banco', label: 'Banco', type: 'text', required: true },
    { name: 'cuenta', label: 'Número de cuenta', type: 'text', required: true },
    { name: 'cedula', label: 'Cédula/RIF', type: 'text', required: true },
    { name: 'tipo_cuenta', label: 'Tipo de cuenta', type: 'select', options: ['Corriente', 'Ahorro'], required: true },
  ],
  deposito: [
    { name: 'banco', label: 'Banco', type: 'text', required: true },
    { name: 'cuenta', label: 'Número de cuenta', type: 'text', required: true },
    { name: 'cedula', label: 'Cédula/RIF', type: 'text', required: true },
  ],
  binance: [
    { name: 'binance_id', label: 'Binance ID', type: 'text', required: true },
    { name: 'email_o_telefono', label: 'Email o Teléfono', type: 'text', required: true },
  ],
  zelle: [
    { name: 'email', label: 'Correo electrónico', type: 'email', required: true },
  ],
  zinli: [
    { name: 'email', label: 'Correo electrónico', type: 'email', required: true },
  ],
  wally: [
    { name: 'telefono', label: 'Teléfono con código de área', type: 'tel', required: true, placeholder: '+58 412...' },
  ],
  custom: [
    { name: 'informacion', label: 'Información de pago', type: 'textarea', required: true },
  ],
};
